import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark1"><Path fillRule="evenodd" clipRule="evenodd" d="M20.5763 5.06558L10.1618 20.9938L3.38493 13.0875L5.6627 11.1351L9.83825 16.0066L18.0654 3.42383L20.5763 5.06558Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1;
